import { render, staticRenderFns } from "./heartbeat.vue?vue&type=template&id=2bc35732&scoped=true"
import script from "./heartbeat.vue?vue&type=script&lang=js"
export * from "./heartbeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc35732",
  null
  
)

export default component.exports